/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConnectedAccountResponse
 */
export interface GetConnectedAccountResponse {
    /**
     * The user ID associated with the provided Discord member ID
     * @type {string}
     * @memberof GetConnectedAccountResponse
     */
    userId?: string;
}

/**
 * Check if a given object implements the GetConnectedAccountResponse interface.
 */
export function instanceOfGetConnectedAccountResponse(value: object): value is GetConnectedAccountResponse {
    return true;
}

export function GetConnectedAccountResponseFromJSON(json: any): GetConnectedAccountResponse {
    return GetConnectedAccountResponseFromJSONTyped(json, false);
}

export function GetConnectedAccountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConnectedAccountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
    };
}

export function GetConnectedAccountResponseToJSON(json: any): GetConnectedAccountResponse {
    return GetConnectedAccountResponseToJSONTyped(json, false);
}

export function GetConnectedAccountResponseToJSONTyped(value?: GetConnectedAccountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
    };
}

